<template>
    <div class="loading" v-if="!chatStore.isLoadedProduct">
      در حال بارگذاری...
    </div>
    <div class="product-list" v-else-if="chatStore.cardsProduct.length>0">
        <CardsChatProduct v-for="product in chatStore.cardsProduct" :key="product.id"
        :class="['product',chatStore.productSelectedId == product.id?'selected':'']" 
        :data="product" @click="select(product)"/>
        <div ref="el" v-if="chatStore.hasMoreProduct"></div>
    </div>
</template>
<script setup>
    import { useTemplateRef } from 'vue'
    import router from '@/router'
    import { useInfiniteScroll } from '@vueuse/core'
    import { polling } from '@/composables/polling'
    import CardsChatProduct from '../cards/CardsChatProduct.vue';
    import { isDefrentChatProductData } from '@/composables/polling/chat/isDefrentChatProductData'
    import { useAlertStore } from '@/stores/alert'
    import { useChatStore } from '@/stores/chat';
    const chatStore = useChatStore()
    const alertStore = useAlertStore()
    const el = useTemplateRef('el')
    polling( 
        async () => await chatStore.fetchChatProduct(chatStore.cardsProduct.length > 0 ? chatStore.cardsProduct.length : 10 , 0 , false),
        {
            oldData:chatStore.cardsProduct??[],
            intervalMs: 6000,
            isDifferent: (newData) => isDefrentChatProductData(chatStore.cardsProduct,newData),
            onChange: (allNewProduct) => {
                if(isDefrentChatProductData(chatStore.cardsProduct??[],allNewProduct??[])){
                    if(chatStore.cardsProduct.length<allNewProduct.length){
                        alertStore.type=true
                        alertStore.msg='تغییرات جدید!'
                    }
                    chatStore.cardsProduct = allNewProduct??[]
                }
            }
        }
    )
    useInfiniteScroll(
        el, 
        async () => {
            await chatStore.fetchChatProduct(10,chatStore.cardsProduct.length,true) 
        } , { 
            distance: 50,
            canLoadMore: () => { 
                return chatStore.hasMoreProduct
            } 
        }
    )
    const select = async (product) => {
        router.push({path:'/show-chat-product/'+product?.id})
    }
</script>
<style scoped>
    .product-list {
        width: 100%;
        background-color: #f1dfdf82;
        display: flex;
        box-sizing: border-box;
        gap: 10px;
        padding: 2px;
        height: 100%;
        flex-direction: column;
        align-items: center;
    }
    .product {
        direction: rtl;
        width: 100%;
        box-sizing: border-box;
        height: 60px;
        display: flex;
        justify-content: space-evenly;
        flex-direction: row;
        flex-wrap: nowrap;
        box-shadow: 1px 0px 10px chartreuse;
        align-items: center;
        cursor: pointer;
        border-radius: 6px;
    }
    .product:hover {
        background: #f3f3f3;
    }
    .selected{
        background: #e0f2ff;
    }
</style>